import { CssBaseline } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components/macro";

import AuthPathBanner from "../components/AuthPathBanner";
import GlobalStyle from "../components/GlobalStyle";
import Settings from "../components/Settings";

const Root = styled.div`
  max-width: 520px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
  flex-direction: column;
`;

const Auth = ({ children }) => {
  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <AuthPathBanner sx={{ mb: 4, width: "100%" }} />
      {children}
      <Outlet />
      <Settings />
    </Root>
  );
};

export default Auth;
